// hooks/requests/talk2pay/use-get-account-status.ts

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { AccountStatusResponse } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseGetAccountStatusReturn = RequestsBaseReturn<AccountStatusResponse | null>;

const useGetAccountStatus = (): UseGetAccountStatusReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<AccountStatusResponse, Error>(
    SWR_KEYS.getAccountStatus,
    () => t2payService.getAccountStatus(),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetAccountStatus;
